<template>
    <div class="pp-card">
        <i v-if="showClose" 
            class="pp-icon-close-fill pp-card__close"
            @click.stop="close"
        ></i>
        <div class="pp-card__body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 * 卡片
 * @desc 未来版本slot传入操作按钮
 * @param {Boolean} showClose 显示关闭按钮
 * @event close 点击关闭按钮触发
 */
export default {
    name: 'pp-card',
    props: {
        showClose: Boolean,
    },
    methods: {
        close: function() {
            this.$emit('close')
        },
    },
}
</script>
